export default {
  getVehicle: (state) => state.vehicle,
}
